module.exports = __webpack_public_path__ + "img/VetoSansCond-CondLight_1.ba1aeecb.svg";